import { Link } from "react-router-dom";

export default function ORSBanner({ children, link }) {
	
	return (
		<Link 
			to={link}
			target="blank"
			className="
				p-2
				bg-speed
				text-black
				
				text-[12px]
				flex justify-center
				cursor-pointer
			"
		>
			{children}
		</Link>
	)
}